var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 30",
    d: "M0 2C0 0.895431 0.895431 0 2 0H20.2222L28 7.70833V34C28 35.1046 27.1046 36 26 36H2C0.895431 36 0 35.1046 0 34V2Z",
    fill: "#6F7EDA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 31",
    d: "M28 7.7085L20.2222 7.7085L20.2222 0.000162322L28 7.7085Z",
    fill: "#253179"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 31V23H7.09105C7.68528 23 8.19153 23.1159 8.60979 23.3477C9.02805 23.5768 9.34685 23.8958 9.56618 24.3047C9.78806 24.7109 9.89901 25.1797 9.89901 25.7109C9.89901 26.2422 9.78679 26.7109 9.56236 27.1172C9.33792 27.5234 9.01275 27.8398 8.58684 28.0664C8.16348 28.293 7.65085 28.4062 7.04897 28.4062H5.07881V27.0508H6.78118C7.09997 27.0508 7.36266 26.9948 7.56924 26.8828C7.77837 26.7682 7.93395 26.6107 8.03596 26.4102C8.14053 26.207 8.19281 25.974 8.19281 25.7109C8.19281 25.4453 8.14053 25.2135 8.03596 25.0156C7.93395 24.8151 7.77837 24.6602 7.56924 24.5508C7.36011 24.4388 7.09487 24.3828 6.77353 24.3828H5.65647V31H4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7523 31H10.9749V23H13.7752C14.5633 23 15.2417 23.1602 15.8104 23.4805C16.3792 23.7982 16.8166 24.2552 17.1226 24.8516C17.4312 25.4479 17.5855 26.1615 17.5855 26.9922C17.5855 27.8255 17.4312 28.5417 17.1226 29.1406C16.8166 29.7396 16.3766 30.1992 15.8028 30.5195C15.2315 30.8398 14.548 31 13.7523 31ZM12.6314 29.5508H13.6834C14.1731 29.5508 14.585 29.4622 14.9191 29.2852C15.2557 29.1055 15.5082 28.8281 15.6765 28.4531C15.8474 28.0755 15.9329 27.5885 15.9329 26.9922C15.9329 26.401 15.8474 25.918 15.6765 25.543C15.5082 25.168 15.257 24.8919 14.9229 24.7148C14.5888 24.5378 14.1769 24.4492 13.6873 24.4492H12.6314V29.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 31V23H24V24.3945H20.469V26.3008H23.6557V27.6953H20.469V31H18.8125Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.6f8b679b8d7645a1ea20dc35a41c3655.svg";
export { ForwardRef as ReactComponent };